import { Wordpress } from "../functions/Woocommerce";

const TOKEN_KEY = "token";

export const login = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isLogin = async () => {
  try {
    const res = await Wordpress.validateJwth();
    return res.data?.code === "jwt_auth_valid_token";
  } catch (err) {
    console.warn("❌ isLogin error:", err.response?.data || err.message);
    return false;
  }
};
